import { Component, OnInit } from '@angular/core';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit {
  blog: any;
  blogdetail: any;
  points: any[] = [];
  introContent: string = '';  
  constructor(private service: ApiServicesService,
    private route: ActivatedRoute,
  ) { }
  ngOnInit(): void {
    window.scrollTo(0, 0);  
    const alias = this.route.snapshot.paramMap.get('alias');
    if (alias) {
      this.fetchBlogDetail(alias);
    }
  }

  fetchBlogDetail(alias: string): void {
    const payload = { alias };
    this.service.post(payload, API_ROUTES.blogsData.blogsDataList, {}).subscribe(
      (res) => {
        if (res.success) {
          this.blog = res.data 
          this.blog = res.data 
          this.blogdetail = res.data
          const [intro, ...pointContent] = this.blog.short_description.split(/(?=\d+\.\s+)/); 
          this.introContent = intro.trim();  
          this.points = pointContent
            .join('\n') 
            .split(/\d+\.\s+/) 
            .filter((point: any) => point.trim()) 
            .map((point: any) => {
              const [title, ...rest] = point.split('\n');
              return { title, content: rest.join('\n').trim() }; 
            });
        } else {
          console.error('Failed to fetch blog detail:', res.message);
        }
      },
      (err) => {
        console.error('Error fetching blog detail:', err);
      }
    );
  }

  formatDate(date: string): string {
    const parsedDate = new Date(date);
    return parsedDate.toISOString().split('T')[0]; 
  }

}